import React from 'react';
import SkeletonBlock from '../../ui/SkeletonBlock';
import SkeletonRoot from '../../ui/SkeletonRoot';

interface PipelineSalesTableSkeletonProps {
  rows?: number;
}

const PipelineSalesTableSkeleton: React.FC<PipelineSalesTableSkeletonProps> = ({
  rows = 8,
}) => {
  const rowItems = Array.from({ length: rows }, (_, index) => index);

  return (
    <SkeletonRoot loadingLabel="Loading opportunities" className="w-full">
      <table className="w-full table-fixed divide-y divide-gray-200">
        <colgroup>
          <col className="w-[14%]" />
          <col className="w-[14%]" />
          <col className="w-[11%]" />
          <col className="w-[11%]" />
          <col className="w-[13%]" />
          <col className="w-[12%]" />
          <col className="w-[6%]" />
          <col className="w-[9%]" />
          <col className="w-[10%]" />
        </colgroup>
        <thead className="bg-slate-50">
          <tr>
            {Array.from({ length: 9 }, (_, index) => (
              <th
                key={index}
                className={`${index === 0 || index === 1 || index === 8 ? 'px-2' : 'px-1.5'} py-1`}
              >
                <SkeletonBlock
                  className={`h-2.5 ${index === 8 ? 'ml-auto w-10' : 'w-3/4'}`}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {rowItems.map((row) => (
            <tr key={row}>
              <td className="px-2 py-0.5">
                <SkeletonBlock className="h-3.5 w-5/6" />
              </td>
              <td className="px-2 py-0.5">
                <SkeletonBlock className="h-3.5 w-11/12" />
              </td>
              <td className="px-1.5 py-0.5">
                <div className="flex items-center gap-1">
                  <SkeletonBlock className="h-4 w-7" />
                  <SkeletonBlock className="h-4 w-6" />
                </div>
              </td>
              <td className="px-1.5 py-0.5">
                <SkeletonBlock className="h-3.5 w-14" />
              </td>
              <td className="px-1.5 py-0.5">
                <SkeletonBlock className="h-4 w-16 rounded-md" />
              </td>
              <td className="px-1.5 py-0.5">
                <div className="flex items-center gap-1">
                  <SkeletonBlock className="h-4 w-4 shrink-0 rounded-full" />
                  <SkeletonBlock className="h-3 w-12" />
                </div>
              </td>
              <td className="px-1.5 py-0.5">
                <SkeletonBlock className="h-3.5 w-8" />
              </td>
              <td className="px-1.5 py-0.5">
                <SkeletonBlock className="h-3.5 w-12" />
              </td>
              <td className="px-2 py-0.5">
                <div className="flex items-center justify-end gap-0.5">
                  <SkeletonBlock className="h-7 w-7 rounded-md" />
                  <SkeletonBlock className="h-7 w-7 rounded-md" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </SkeletonRoot>
  );
};

export default PipelineSalesTableSkeleton;
